export default __webpack_public_path__ + "static/media/session.9cb67abd.svg";